import { debounce } from 'lodash';

import { isTesting } from 'js/src/libs/custom-utils';

/**
 * Controls driven by a slider update luminary immediately, because that gives the user immediate visual
 * feedback on their change. However, for each minute change we don't want to send analytics and
 * checkpoint the video. Instead, by debouncing, we can wait until the user has settled on a value.
 */
export const debounceOneSecond = debounce(
    (callback: () => void) => {
        callback();
    },
    isTesting() ? 0 : 1000,
);
